const query = document.querySelector.bind(document);
const queryAll = document.querySelectorAll.bind(document);

const checkIfValid = () => {
    queryAll("input, select, textarea").forEach( e =>{
        e.addEventListener("invalid", () => {
                e.classList.add("invalid");
            }),
            e.addEventListener("input", () => {
                e.validity.valid && e.classList.remove("invalid");
            })
    })
};
checkIfValid()